/**
 * =============================================
 * UTILITARIO DE EXPORTACAO EXCEL
 * =============================================
 * Arquivo: excelExport.ts
 * Descricao: Exportacao de dados tabulares para Excel (.xlsx)
 * Usa biblioteca xlsx (SheetJS).
 * =============================================
 */
import * as XLSX from 'xlsx';

export interface ExcelColumn<T> {
  header: string;
  key: keyof T | ((row: T) => unknown);
  width?: number;
}

export function exportToExcel<T>(options: {
  data: T[];
  columns: ExcelColumn<T>[];
  fileName: string;
  sheetName?: string;
}) {
  const { data, columns, fileName, sheetName = 'Relatorio' } = options;

  const rows = data.map(item => {
    const row: Record<string, unknown> = {};
    for (const col of columns) {
      const value = typeof col.key === 'function' ? col.key(item) : item[col.key as keyof T];
      row[col.header] = value === null || value === undefined ? '' : value;
    }
    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(rows, {
    header: columns.map(c => c.header)
  });

  // Ajusta largura das colunas
  const colWidths = columns.map(c => ({ wch: c.width ?? 18 }));
  worksheet['!cols'] = colWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const safeName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
  XLSX.writeFile(workbook, safeName);
}
